import React, { useState } from 'react';
import { AboutBanner } from './components/AboutBanner';
import { AboutStoryPills } from './components/AboutStoryPills';
import { AboutMission } from './components/AboutMission';
import { AboutVision } from './components/AboutVision';
import { Helmet } from 'react-helmet';
type Props = {
  className?: string;
};

export const About: React.FC<Props> = () => {
  const [selection, set] = useState(0);
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>About TableTab | TableTab</title>
        <meta name="robots" content="index, follow" />
        <meta
          name="description"
          content="TableTab is on a mission to help restaurants thrive by enabling a safe, profitable, sustainable, and enjoyable operation with mobile order and payment. Learn more about our company and story."
        />
        <link rel="canonical" href="https://tabletab.io/about/" />
      </Helmet>
      <AboutBanner className={'mt-10 lg:mt-20 2xl:mt-32'} />
      <AboutStoryPills
        selection={selection}
        onClick={s => {
          set(s);
        }}
        className={''}
      />
      {selection == 0 ? (
        <>
          {' '}
          <AboutMission className={'mt-16 lg:mt-32'} />{' '}
          <AboutVision className={'mt-16 lg:mt-32'} />{' '}
        </>
      ) : selection == 1 ? (
        <AboutMission className={'mt-16 lg:mt-32'} />
      ) : (
        <AboutVision className={'mt-16 lg:mt-32'} />
      )}
    </>
  );
};

export default About;
